import React, { useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { BsArrowLeft } from 'react-icons/bs'
import NavigationButtons from '../Navigation Buttons/Navigation Buttons'
import Heading from '../Heading/Heading'
import Loader from '../Loader/Loader'
import { useNavigate } from 'react-router-dom'
import TeamList from './TeamList'
import ConfirmationModal from '../Confirmation Modal/ConfirmationModal'
import { toast } from 'react-toastify'

export default function MyTeam({onLogout}) {
  // Define
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showConfirmationModalForLogout, setShowConfirmationModalForLogout] =
      useState(false);
  const [LogoutClicked, setLogoutClicked] = useState(false);


  // Functions 
  const handleBack = () => {
    navigate("/user/dashboard");

  };


    const handleConfirmationForLogoutYes = () => {
      localStorage.clear();
      toast.success("Logged out successfully!");
      onLogout();
  
      if (onLogout) {
        navigate("/");
      }
      navigate("/");
    };
  
    const handleConfirmationForLogoutNo = () => {
      setShowConfirmationModalForLogout(false);
      setLogoutClicked(false);
    };


  const handleUpdatePersonalDetails = () => {
    navigate("/user/update_profile");
  };



  const handleLogout = () => {
    setShowConfirmationModalForLogout(true);
    setLogoutClicked(true);
  };


  return (
    <>
          {/* Top navigation */}
          <Row className="mb-2">
            {/* Back Button */}
    
            <Col>
              <Button
                className="back-button"
                variant=""
                onClick={handleBack}
                style={{
                  // backgroundColor: "#f0f8ff",
                  color: "#055837",
                  marginLeft: "25px",
                }}
              >
                <BsArrowLeft className="me-0" /> Back to Dashboard
              </Button>
            </Col>
    
            <Col>
              <NavigationButtons
                handleUpdatePersonalDetails={handleUpdatePersonalDetails}
                handleLogout={handleLogout}
              />
            </Col>
          </Row>
    
          <Heading text="My Team" />
    
          {loading && (
            <Loader />
          )}

          <TeamList />

          {LogoutClicked && (
            <ConfirmationModal
              show={showConfirmationModalForLogout}
              onHide={handleConfirmationForLogoutNo}
              onConfirm={handleConfirmationForLogoutYes}
              title="Confirm Logout"
              message="Are you sure you want to log out?"
            />
          )}
    </>
  )
}
